<template>
    <v-card outlined
            :id="uID">
        <v-card-subtitle class="primary lighten-4 py-1">
            <v-row class="mx-2 my-0">
                <div class="text-primary darken-4">
                    {{ title }}
                </div>

                <v-spacer></v-spacer>
                <v-btn icon small @click="onClose"
                       v-if="panel === 0">
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
                <v-btn icon small @click="onOpen"
                       v-if="panel !== 0">
                    <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
            </v-row>
        </v-card-subtitle>
        <v-expansion-panels v-model="panel">
            <v-expansion-panel>
                <v-expansion-panel-content>
                    <v-container fluid style="padding-top: 26px;">
                        <slot></slot>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
        },
        computed: {
            uID() {
                return this._uid.toString();
            },
        },
        mounted() {
            this.$nextTick(function () {
                console.log(`mounted ${this.uID}`);
                this.onOpen();
            });
        },
        data: () => ({
            panel: 0,
        }),
        methods: {
            onOpen() {
                this.panel = 0;
            },
            onClose() {
                this.panel = [];
            },
        },
    };
</script>
